// We need this for Tiptap in Safari 14: https://github.com/ueberdosis/tiptap/issues/6785
// The proper way to polyfill is with modern Babel config or using corejs v3
// (`import 'core-js/actual/array/find-last';`), but we're stuck on older versions.

if (!(Array.prototype as any).findLast) {
  ;(Array.prototype as any).findLast = function <T>(
    predicate: (value: T, index: number, array: T[]) => boolean,
    thisArg?: unknown
  ): T | undefined {
    for (let i = this.length - 1; i >= 0; i--) {
      if (predicate.call(thisArg, this[i], i, this)) {
        return this[i]
      }
    }
    return undefined
  }
}
